import CookieManager from '../utils/cookie-manager';

export default function initPreHeader() : void {
    const $preHeader = document.querySelector('.js-pre-header');

    if (!$preHeader) {
        return;
    }

    const $closeBtn = $preHeader.querySelector('.js-pre-header-close-btn');

    if (!$closeBtn) {
        return;
    }

    $closeBtn.addEventListener('click', () => {
        $preHeader.remove();
        CookieManager.setCookie('pre-header-closed', 'true');
        document.dispatchEvent(new CustomEvent('close-pre-header'));
    });
}
